export type TopicFeaturedItem = {
  title: string;
  description?: string;
  href: string;
};

export const TOPIC_FEATURED_POSTS: Record<string, TopicFeaturedItem[]> = {
  observability: [
    {
      title: "What Is Observability?",
      description:
        "Learn what observability is and how it helps you monitor and troubleshoot systems efficiently.",
      href: "/blog/observability/",
    },
    {
      title: "Observability Tools",
      description: "Discover best observability tools to track, analyze, and optimize your applications.",
      href: "/blog/observability/tools/",
    },
    {
      title: "LLM Observability",
      description:
        "See how to monitor large language models and ensure AI reliability.",
      href: "/blog/llm-observability/",
    },
  ],
  monitoring: [
    {
      title: "What is Infrastructure Monitoring?",
      description:
        "Learn how to monitor system health proactively and prevent outages before they occur.",
      href: "/blog/what-is-infrastructure-monitoring/",
    },
    {
      title: "What is Application Performance Monitoring?",
      description: "Explore how APM monitor apps, detects issues, and optimize performance in real time.",
      href: "/blog/what-is-application-performance-monitoring/",
    },
    {
      title: "Intro to Middleware's Real User Monitoring (RUM)",
      description:
        "Understand how how real users interact with your apps using Middleware RUM insights.",
      href: "/blog/real-user-monitoring-with-middleware/",
    },
  ],
  opentelemetry: [
    {
      title: "What is OpenTelemetry",
      description:
        "Learn what is OpenTelemetry and how it collects traces, metrics, and logs for observability.",
      href: "/blog/what-is-opentelemetry/",
    },
    {
      title: "OpenTelemetry vs Prometheus",
      description: "See the comparison between OpenTelemetry and Prometheus for monitoring and observability needs.",
      href: "/blog/opentelemetry-vs-prometheus/",
    },
    {
      title: "OpenTelemetry Observability",
      description:
        "Gain full observability by tracking metrics, logs, and traces with OpenTelemetry.",
      href: "/blog/opentelemetry-observability/",
    },
  ],
  logging: [
    {
      title: "Log Monitoring",
      description:
        "Learn what log monitoring is and how it tracks and analyzes logs to detect system issues",
      href: "/blog/what-is-log-monitoring/",
    },
    {
      title: "Log Levels",
      description: "Understand log levels and how to use them effectively in monitoring setups.",
      href: "/blog/log-levels-guide/",
    },
    {
      title: "Kubectl Logs Tail: How to View Kubernetes Logs",
      description:
        "Learn how to view and debug Kubernetes pod logs using kubectl commands.",
      href: "/blog/kubectl-logs-tail/",
    },
  ],
  devops: [
    {
      title: "What is DevOps",
      description:
        "Learn how DevOps improves collaboration, automation, and software delivery.",
      href: "/blog/what-is-devops/",
    },
    {
      title: "What Is a CI/CD Pipeline",
      description: "Understand CI/CD pipelines and how each stage works to automate build, test, deploy.",
      href: "/blog/what-is-a-ci-cd-pipeline/",
    },
    {
      title: "What are Microservices?",
      description:
        "Learn how microservices break apps into services for scalability and agility.",
      href: "/blog/microservices-architecture/",
    },
  ],
  kubernetes: [
    {
      title: "Kubernetes Monitoring: A Complete Guide",
      description:
        "Learn how to monitor Kubernetes clusters to ensure performance and reliability.",
      href: "/blog/kubernetes-monitoring/",
    },
    {
      title: "Top Kubernetes Monitoring Tools",
      description: "Explore the best kubernetes monitoring tools for tracking metrics and health of K8 clusters.",
      href: "/blog/kubernetes-monitoring/tools/",
    },
    {
      title: "Exit Code 137 in Kubernetes",
      description:
        "Understand causes of exit code 137 in kubernetes and how to diagnose and fix it.",
      href: "/blog/exit-code-137-in-kubernetes-causes-diagnosis-fixes/",
    },
  ],
  cloud: [
    {
      title: "Cloud Infrastructure Guide",
      description:
        "Learn cloud components, architecture, and best practices for deployment.",
      href: "/blog/cloud-infrastructure-guide/",
    },
    {
      title: "Cloud Monitoring Tools",
      description: "Explore cloud monitoring tools to track performance, health, and reliability in the cloud.",
      href: "/blog/cloud-monitoring-tools/",
    },
    {
      title: "Cloud Load Balancing: Types, Benefits, and Best Practices",
      description:
        "Understand load balancing, its types, and how it improves cloud performance.",
      href: "/blog/cloud-load-balancing/",
    },
  ],
  containers: [
    {
      title: "What is Containerization",
      description:
        "Learn how containerization packages applications for consistent and portable deployment.",
      href: "/blog/containerization/",
    },
    {
      title: "Container Monitoring",
      description: "Learn how to monitor container performance, logs, and resource usage in real time.",
      href: "/blog/container-monitoring/",
    },
    {
      title: "Helm Chart Tutorial: Step-by-Step Guide for Beginners",
      description:
        "Learn how to use Helm charts to package, configure, and deploy Kubernetes applications.",
      href: "/blog/helm-chart-tutorial/",
    },
  ],
  performance : [
    {
      title: "How to Reduce MTTR",
      description:
        "Learn strategies to reduce MTTR and improve incident detection, response, and recovery.",
      href: "/blog/how-to-reduce-mttr/",
    },
    {
      title: "Fix Application Performance Issues",
      description: "Know how to identify root causes and resolve application performance issues.",
      href: "/blog/fix-application-performance-issues/",
    },
    {
      title: "Core Web Vitals with RUM and Synthetic Monitoring",
      description:
        "Learn how to track and improve Core Web Vitals using RUM and synthetic monitoring.",
      href: "/blog/core-web-vitals-with-rum-synthetic-monitoring/",
    },
  ],
  data : [
    {
      title: "Structured vs Unstructured Data",
      description:
        "Understand key differences in data types, storage formats, and use cases.",
      href: "/blog/structured-vs-unstructured-data/",
    },
    {
      title: "What is Autoscaling",
      description: "Explore how autoscaling automatically adjusts resources based on real-time demand.",
      href: "/blog/what-is-autoscaling/",
    },
    {
      title: "What Is Cloud Analytics? Complete Guide",
      description:
        "Learn how cloud analytics processes large-scale data to deliver actionable insights.",
      href: "/blog/what-is-cloud-analytics/",
    },
  ],
  ai : [
    {
      title: "What Is AIOps? Complete Guide",
      description:
        "Understand how AI-driven automation improves IT operations and incident resolution.",
      href: "/blog/what-is-ai-ops/",
    },
    {
      title: "Introducing Middleware OpsAI: The AI SRE Agent That Resolves Production Issues Before They Reach Your Users",
      description: "Explore how OpsAI detects, analyzes, and resolves production issues automatically.",
      href: "/blog/ops-ai-sre-agent/",
    },
    {
      title: "Introducing the Fastest AI Dashboard Builder",
      description:
        "Understand how Middleware AI speeds up dashboard creation and observability visualization.",
      href: "/blog/introducing-fastest-ai-dashboard-builder/",
    },
  ]
};

export function getTopicFeaturedPosts(tagSlug: string | undefined): TopicFeaturedItem[] {
  if (!tagSlug) return [];
  const list = TOPIC_FEATURED_POSTS[tagSlug.toLowerCase()];
  return Array.isArray(list) ? list.slice(0, 3) : [];
}
